<div
  class="truncated-text"
  #truncatedTextRef
  [accredibleTooltip]="isTruncated ? text : ''"
  [tooltipDirection]="tooltipDirection">
  {{ text }}
</div>
